import { useServicesQuery } from '@/services/api';
import { SESSION_METADATA_REFETCH_INTERVAL } from '@/features/account-switcher/constants';

/**
 * useAccountMemberships returns the accounts the current login belongs to.
 *
 * A login has more than one membership only once it has been added to multiple
 * accounts (the decoupled-accounts flows), which the backend gates behind its
 * membership-auth flag. So `data.length > 1` is a self-gating signal that
 * account switching is available — no separate capability flag is needed.
 */
export function useAccountMemberships() {
  return useServicesQuery(
    'getMemberships',
    {},
    {
      refetchInterval: SESSION_METADATA_REFETCH_INTERVAL,
      refetchOnMount: 'always',
      refetchOnWindowFocus: 'always',
    },
  );
}
